import { ScopeOverviewResponse, ScopeResponse } from '@ydistri/api-sdk';

export interface ScopeListCacheFilter {
  search?: string;
}

export const isScopeSignalForProject = (
  signalProjectSlug: string,
  projectShortName: string,
): boolean => signalProjectSlug.toLowerCase() === projectShortName.toLowerCase();

export const toScopeOverview = (scope: ScopeResponse): ScopeOverviewResponse => ({
  scopeId: scope.scopeId,
  scopeSourceTypeId: scope.scopeSourceTypeId,
  name: scope.name,
  createdAt: scope.createdAt,
  updatedAt: scope.updatedAt,
  archivedAt: scope.archivedAt,
  isArchived: scope.isArchived,
  isShared: scope.isShared,
  sectionCount: scope.sections.length,
});

export const shouldListScope = (
  scope: ScopeOverviewResponse,
  filter: ScopeListCacheFilter,
): boolean => {
  const normalizedSearch = filter.search?.trim().toLocaleLowerCase();
  return !normalizedSearch || scope.name.toLocaleLowerCase().includes(normalizedSearch);
};

interface ScopeSnapshot {
  updatedAt: string;
}

export const isScopeSnapshotNewer = (
  currentScope: ScopeSnapshot,
  changedScope: ScopeSnapshot,
): boolean => {
  const currentUpdatedAt = Date.parse(currentScope.updatedAt);
  const changedUpdatedAt = Date.parse(changedScope.updatedAt);

  if (Number.isNaN(changedUpdatedAt)) return false;
  if (Number.isNaN(currentUpdatedAt)) return true;

  return changedUpdatedAt > currentUpdatedAt;
};

export const applyScopeChangeToList = (
  scopes: ReadonlyArray<ScopeOverviewResponse>,
  changedScope: ScopeOverviewResponse,
  filter: ScopeListCacheFilter,
  lastKnownScope?: ScopeOverviewResponse,
): ScopeOverviewResponse[] => {
  const currentScope =
    lastKnownScope ?? scopes.find(scope => scope.scopeId === changedScope.scopeId);
  if (currentScope && !isScopeSnapshotNewer(currentScope, changedScope)) return [...scopes];

  const withoutChangedScope = scopes.filter(scope => scope.scopeId !== changedScope.scopeId);
  const nextScopes = shouldListScope(changedScope, filter)
    ? [...withoutChangedScope, changedScope]
    : withoutChangedScope;

  return nextScopes.sort((left, right) => left.name.localeCompare(right.name));
};
